var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as users } from '@web/lib/demo/data/users';
import { getUsers } from '@web/lib/demo/utils';
import { toTeamAverageMeetingsTypes } from '@workalizer/shared/services/processMeetingsAnalytic';
import { formatDuration, getTeamMemberIds, randomInt } from '@workalizer/shared/utils';
var DEMO_TEAM_MEMBER_COUNT = 4;
var RECURRING_MEETING_TITLES = [
    'Weekly Team Standup',
    'Sprint Planning',
    'Engineering Sync',
    '1:1 with Manager',
    'Product Review',
    'All-Hands Prep',
    'Backlog Grooming',
    'Design Critique',
    'Retrospective',
    'Roadmap Check-in'
];
var OCCASIONAL_MEETING_TITLES = [
    'Project Kickoff',
    'Ad-hoc Brainstorm',
    'Incident Postmortem',
    'Quick Sync',
    'Architecture Discussion',
    'Hiring Debrief',
    'Budget Review',
    'Cross-team Alignment',
    'Release Readiness',
    'Stakeholder Walkthrough'
];
var EXTERNAL_MEETING_TITLES = [
    'Client Call — Acme Corp',
    'Vendor Demo',
    'Partner Onboarding',
    'Customer QBR',
    'External Stakeholder Update',
    'Sales Discovery Call',
    'Contract Negotiation',
    'Support Escalation Review',
    'Investor Update',
    'Agency Weekly Sync'
];
var generateMeetingsList = function (count, titles) {
    var listCount = Math.min(count, randomInt(5, 9));
    return Array.from({ length: listCount }, function (_, index) {
        var durationSeconds = randomInt(20, 75) * 60;
        return {
            title: titles[index % titles.length],
            duration: formatDuration(durationSeconds, 'seconds')
        };
    });
};
var generateTypeItem = function (titles, countRange) {
    var count = randomInt(countRange[0], countRange[1]);
    var avgDurationSeconds = randomInt(28, 52) * 60;
    return {
        count: count,
        durationSeconds: count * avgDurationSeconds,
        meetingsList: generateMeetingsList(count, titles)
    };
};
var generateMeetingsTypesData = function (input) {
    var isSingleUser = Boolean(input.userId);
    var usersInScope = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var scopeMultiplier = isSingleUser ? 1 : Math.max(usersInScope.length, 3);
    var recurring = generateTypeItem(RECURRING_MEETING_TITLES, [
        Math.round(8 * scopeMultiplier),
        Math.round(24 * scopeMultiplier)
    ]);
    var occasional = generateTypeItem(OCCASIONAL_MEETING_TITLES, [
        Math.round(6 * scopeMultiplier),
        Math.round(18 * scopeMultiplier)
    ]);
    var external = generateTypeItem(EXTERNAL_MEETING_TITLES, [
        Math.round(4 * scopeMultiplier),
        Math.round(14 * scopeMultiplier)
    ]);
    return {
        companyInternalRecurring: recurring,
        companyInternalOccasional: occasional,
        withExternalParticipants: external
    };
};
var generateTeamTotals = function () { return ({
    companyInternalRecurring: generateTypeItem(RECURRING_MEETING_TITLES, [28, 52]),
    companyInternalOccasional: generateTypeItem(OCCASIONAL_MEETING_TITLES, [20, 40]),
    withExternalParticipants: generateTypeItem(EXTERNAL_MEETING_TITLES, [12, 28])
}); };
export var meetingsTypesAnalytic = function (input) {
    var _a, _b, _c, _d;
    var data = generateMeetingsTypesData(input);
    if (!input.userId) {
        return __assign(__assign({}, data), { teamAverage: null });
    }
    var orgUnitId = (_a = input.orgUnitId) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = users.find(function (user) { return user.id === input.userId; })) === null || _b === void 0 ? void 0 : _b.userOrgUnits) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.orgUnit.id;
    var teamUserIds = getTeamMemberIds(users
        .filter(function (user) {
        var _a;
        return orgUnitId
            ? (_a = user.userOrgUnits) === null || _a === void 0 ? void 0 : _a.some(function (unit) { return unit.orgUnit.id === orgUnitId; })
            : true;
    })
        .map(function (user) { return user.id; }), input.userId);
    if (teamUserIds.length === 0) {
        return __assign(__assign({}, data), { teamAverage: null });
    }
    var teamTotals = generateTeamTotals();
    return __assign(__assign({}, data), { teamAverage: toTeamAverageMeetingsTypes(teamTotals, teamUserIds.length || DEMO_TEAM_MEMBER_COUNT) });
};
